import React, { useState } from 'react';
import PageHeader from '../components/ui/PageHeader';
import CatalogueSubmissionsList from '../features/review/CatalogueSubmissionsList';
import PackingAlertsPanel from '../features/catalogue/PackingAlertsPanel';

/**
 * Review — daily work for an admin, not configuration, so it sits with the
 * working screens in the sidebar rather than under Admin Settings.
 *
 * Two queues, each counted in its own heading:
 *   - Catalogue additions: items a quotation user typed because Master
 *     Catalogue had never heard of them, waiting to be approved, edited then
 *     approved, or rejected.
 *   - Packing alerts: MOVED here from a modal on the Master Catalogue page
 *     (owner's call, 2026-09-23 — "out of the modal buried in the Master
 *     Catalogue page where nobody finds it"). Same list, same API, same
 *     permission rule; only the screen it renders on changed.
 *
 * Each section reports its own pending total back up to this page's headings
 * (`onTotalChange`) rather than this page issuing a second, redundant fetch of
 * a count each section already has to read to render itself.
 */
export default function ReviewPage() {
  const [pendingAdditions, setPendingAdditions] = useState(0);
  const [pendingPacking, setPendingPacking] = useState(0);

  return (
    <div className="flex h-full flex-col">
      <PageHeader
        title="Review"
        subtitle="Catalogue additions submitted from quotations, and packaging that needs a second look."
      />
      <div className="flex-1 min-h-0 overflow-auto px-4 py-4 sm:px-8 sm:py-6">
        <div className="flex flex-col gap-8">
          <section>
            <h2 className="text-sm font-semibold text-slate-900">Catalogue additions ({pendingAdditions})</h2>
            <div className="mt-2">
              <CatalogueSubmissionsList onTotalChange={setPendingAdditions} />
            </div>
          </section>

          <section>
            <h2 className="text-sm font-semibold text-slate-900">Packing alerts ({pendingPacking})</h2>
            <div className="mt-2">
              <PackingAlertsPanel onTotalChange={setPendingPacking} />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
